import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Superadminprofile.css";
// import admin_img from "../../../images/admin-img.svg";
import profile_picture from "../../../images/profile_picture.svg";
import { fetchProfileData } from "../../../Services/Profile/ProfileApi";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import chevronleft from "../../../images/chevronleft.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function SuperadminprofileComp() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.fetchProfileData);
  const [profile, setProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const [userEmail, setuseremail] = useState();

  const userId = localStorage.getItem("user_id");
  const userType = localStorage.getItem("user_type");

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchProfileData(userId)).finally(() => setLoading(false));
  }, [dispatch]);

  useEffect(() => {
    if (data) {
      setProfile(data.user_details);
      setuseremail(data?.user_details?.email);
    }
  }, [data]);

  const handleSendEmail = () => {
    if (data) {
      navigate(`/change-password?email=${encodeURIComponent(userEmail)}`); // Pass email as a query parameter
    }
  };

  const handleUpdateProfile=()=>{
    navigate('/super-admin/update-profile',{ state: { profileData: profile } })
  }
  return (
    <>
    
      <div className="admin-profile-section superadmin">
      <div className="back-btn">
        <button onClick={() => navigate(-1)} className="back-btn-button">
          {/* <img src={chevronleft} alt="chevron-left" className="left-icon" />
           */}
          <ArrowBackIcon className="left-icon" />
          Back
        </button>
      </div>
        <div className="admin-profile-wrapper">
          <div className="admin-profile-inner">
            <div className="admin-content-block d-flex flex-column">
              <div className="admin-pic-name">
                <div className="admin-img">
                  <img
                    src={profile?.image || profile_picture}
                    alt="Profile-picture"
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop
                      e.target.src = profile_picture; // Fallback image
                    }}
                  />
                </div>
                <div className="admin-name">
                  {profile?.first_name} {profile?.last_name}
                </div>
                <div className="admin-designation">{userType}</div>
              </div>
              <div className="admin-main-details">
                <div className="personal-details text-center">
                  Personal Details
                </div>
                <div className="table-admin">
                  <div className="table-admin-inner">
                    <table class="table table-borderless table-desktop-view">
                      <thead className="profile-table-block">
                        <tr>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Designation</th>
                          <th>Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{profile?.first_name}</td>
                          <td>{profile?.last_name}</td>
                          <td>{userType}</td>
                          <td>{profile?.address}</td>
                        </tr>
                        <tr className="profile-table-block">
                          <th colspan="2">Business Email</th>
                          <th>Phone Number</th>
                        </tr>
                        <tr>
                          <td colspan="2">{profile?.email}</td>
                          <td>{profile?.phone_number}</td>
                        </tr>
                      </tbody>
                      {/* <tbody className='table-mobile-view'>
                                                <tr>
                                                    <td>Daniel</td>
                                                    <td>Onesia</td>
                                                    <td>Sales Manager</td>
                                                    <td>New York, United States</td>
                                                </tr>
                                                <tr>
                                                    <th colspan="2">Business Email</th>
                                                    <th>Phone Number</th>

                                                </tr>
                                                <tr>
                                                    <td colspan="2">danny@example.com</td>
                                                    <td>+01 12345 67890</td>
                                                </tr>
                                            </tbody> */}
                    </table>
                    <table class="table table-borderless table-mobile-view">
                      <tbody>
                        <tr className="d-grid row-superadmin">
                          <td>{profile?.first_name}</td>
                          <td>{profile?.last_name}</td>
                          <td>{userType}</td>
                          <td>{profile?.address}</td>
                          <td>{profile?.email}</td>
                          <td className="ph_number">{profile?.phone_number}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="change-edit-btns d-flex gap-3 justify-content-end ">
              <div className="change-pw-btn text-end mt-3">
              <button onClick={handleSendEmail}>Change Password</button>
              </div>
              <div className="editprofile-btn text-end mt-3">
                <button onClick={handleUpdateProfile}>Edit Profile</button>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
}

export default SuperadminprofileComp;
